import { Checkbox, ComboBox, DefaultButton, Dropdown, Panel, PanelType, PrimaryButton, SelectionMode, TextField } from '../../fluent';
import { List } from 'linq.ts';
import React from 'react';
import { paginateData } from '../helpers/paginate-data';
import { isNull, isNullOrEmpty } from '../helpers/string-helper';
import { validateObject, validateProperty, validator } from '../helpers/validations';
import { DataTable } from './DataTable';
import { ExtendedDatePicker } from './ExtendedDatePicker';
import { Grid } from './Grid';
import { Row } from './Row';
const c_div = (props, ...children) => {
    if (isNull(props)) {
        props = {};
    }
    return React.createElement("div", null, children && children.map(o => o));
};
const c_grid = (props, ...children) => {
    if (isNull(props)) {
        props = {};
    }
    if (typeof props.visible === 'boolean' && props.visible === false) {
        return void 0;
    }
    return React.createElement(Grid, null, children && children.map(o => o));
};
const c_row = (props, ...children) => {
    if (isNull(props)) {
        props = {};
    }
    if (typeof props.visible === 'boolean' && props.visible === false) {
        return void 0;
    }
    return React.createElement(Row, null, children && children.map(o => o));
};
const c_col = (props, ...children) => {
    if (isNull(props)) {
        props = {};
    }
    if (typeof props.visible === 'boolean' && props.visible === false) {
        return void 0;
    }
    const colLg = props.colLg || 12;
    const colMd = props.colMd || 12;
    const colSm = props.colSm || 12;
    const className = `ms-Grid-col ms-sm${colLg} ms-md${colMd} ms-lg${colSm}`;
    return React.createElement("div", { className: className }, children && children.map(o => o));
};
const c_textField = (props) => {
    if (isNull(props)) {
        props = {};
    }
    return React.createElement(TextField, { label: props.label || '', placeholder: props.placeholder || '', required: props.required || false, disabled: props.disabled || false, maxLength: props.maxLength || 0, onChange: (_, value) => props.onChanged(value), errorMessage: props.errorMessage || '', value: props.value || '', multiline: props.multiline || false });
};
const c_combobox = (props) => {
    if (isNull(props)) {
        props = {};
    }
    if (typeof props.visible === 'boolean' && props.visible === false) {
        return void 0;
    }
    return React.createElement(ComboBox, { selectedKey: props.selectedKey, label: props.label || '', autoComplete: 'on', disabled: props.disabled || false, useComboBoxAsMenuWidth: true, options: props.options || [], errorMessage: props.errorMessage || '', onChange: (_, option) => props.onChanged(option), required: props.required || false });
};
const c_Datatable = (props) => {
    if (isNull(props)) {
        props = {};
    }
    return React.createElement(DataTable, { allowSearch: props.allowSearch || false, onDownloadServerData: (request) => {
            return new Promise((resolve) => {
                if (typeof props.paginateAsync === 'function') {
                    const result = props.paginateAsync(request);
                    if (isNull(result.Data)) {
                        result.Data = [];
                    }
                    if (typeof result.RecordsFiltered === 'undefined') {
                        result.RecordsFiltered = 0;
                    }
                    resolve(result);
                }
                resolve({
                    Data: [],
                    RecordsFiltered: 0
                });
            });
        }, onSelectedRow: typeof props.onSelectedRow === 'function' ? props.onSelectedRow.bind(this) : void 0, selectionMode: props.selectionMode || SelectionMode.single, columns: props.columns || [], title: props.title || '', commandBarItems: props.commandBarItems || [], searchTooltip: props.searchTooltip || '', refreshOnInit: props.refreshOnInit || false, ref: props.ref });
};
const c_PrimaryButton = (props) => {
    if (isNull(props)) {
        props = {};
    }
    return React.createElement(PrimaryButton, { text: props.text || '', primary: props.primary || true, onClick: () => {
            if (typeof props.onClick === 'function') {
                props.onClick();
            }
        } });
};
const c_DefaultButton = (props) => {
    if (isNull(props)) {
        props = {};
    }
    return React.createElement(DefaultButton, { text: props.text || '', primary: props.primary || false, onClick: () => {
            if (typeof props.onClick === 'function') {
                props.onClick();
            }
        } });
};
const c_panel = (props, ...children) => {
    if (isNull(props)) {
        props = {};
    }
    return React.createElement(Panel, { isOpen: props.isOpen || false, type: props.type || PanelType.smallFixedFar, headerText: props.headerText || '', isFooterAtBottom: props.isFooterAtBottom || true, onRenderFooterContent: () => {
            if (typeof props.onRenderFooterContent === 'function') {
                return props.onRenderFooterContent();
            }
            return React.createElement("div", null);
        }, hasCloseButton: false, closeButtonAriaLabel: props.closeButtonAriaLabel || '' }, children && children.map(o => o));
};
const c_datePicker = (props) => {
    if (isNull(props)) {
        props = {};
    }
    return React.createElement(React.Fragment, null,
        React.createElement(ExtendedDatePicker, { label: props.label || '', onChanged: (value) => {
                if (typeof props.onSelectDate === 'function') {
                    props.onSelectDate(value);
                }
            }, value: props.value || '', isRequired: props.isRequired || false, disabled: props.disabled || false }),
        React.createElement("small", { style: { color: '#bb3737' } }, props.errorMessage || ''));
};
const c_checkbox = (props) => {
    if (isNull(props)) {
        props = {};
    }
    if (typeof props.visible === 'boolean' && props.visible === false) {
        return void 0;
    }
    return React.createElement(Checkbox, { label: props.label || '', checked: props.checked || false, onChange: props.onChange, disabled: props.disabled || false });
};
const c_dropdown = (props) => {
    if (isNull(props)) {
        props = {};
    }
    if (typeof props.visible === 'boolean' && props.visible === false) {
        return void 0;
    }
    return React.createElement(Dropdown, { label: props.label, selectedKeys: props.selectedKeys, required: props.required || false, onChanged: props.onChanged, multiSelect: true, errorMessage: props.errorMessage || '', options: props.options || [], disabled: props.disabled || false });
};
export class ScriptComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
    }
    componentDidMount() {
        if (isNullOrEmpty(this.props.script)) {
            return;
        }
        const sdk = Object.assign(Object.assign({}, this.props.sdk), { validator: validator, validateModel: validateObject, validateProperty: validateProperty, isNullOrEmpty: isNullOrEmpty, paginateData: paginateData, List: List });
        let func;
        // Compile function
        try {
            func = new Function('sdk', 'Sdk', 'div', 'Grid', 'Row', 'Col', 'TextField', 'ComboBox', 'DataTable', 'Panel', 'PrimaryButton', 'DefaultButton', 'PanelType', 'DatePicker', 'Checkbox', 'Dropdown', `${this.props.script || ''}`);
        }
        catch (error) {
            throw Error('Error compiling the component');
        }
        // Create instance of custom component
        try {
            const compileClass = func(sdk, sdk, c_div, c_grid, c_row, c_col, c_textField, c_combobox, c_Datatable, c_panel, c_PrimaryButton, c_DefaultButton, PanelType, c_datePicker, c_checkbox, c_dropdown);
            this._customComponent = new compileClass(this.props.props);
            this._customComponent.onChange = (value) => {
                if (typeof this.props.onChange === 'function') {
                    this.props.onChange(value);
                }
            };
        }
        catch (error) {
            console.error(error);
            throw Error('Error create an instance of the component');
        }
        // Map setState function
        this._customComponent.setState = (newState, callback) => {
            try {
                this._customComponent.state = Object.assign(Object.assign({}, this._customComponent.state), newState);
                this.setState({}, () => {
                    if (typeof callback === 'function') {
                        callback(newState);
                    }
                });
            }
            catch (error) {
                console.error(error);
                throw Error('Error setting state');
            }
        };
        // Execute componentDidMount event
        if (typeof this._customComponent.componentDidMount === 'function') {
            try {
                this._customComponent.componentDidMount();
            }
            catch (error) {
                console.error(error);
                throw Error('Error on componentDidMount');
            }
        }
    }
    componentWillReceiveProps(props) {
        if (this._customComponent != null) {
            if (typeof this._customComponent.componentWillReceiveProps === 'function') {
                this._customComponent.componentWillReceiveProps(props.props);
            }
        }
    }
    render() {
        if (isNull(this._customComponent)) {
            return React.createElement(React.Fragment, null);
        }
        return this._customComponent.render();
    }
    isValid() {
        if (this._customComponent != null) {
            return this._customComponent.onValidate() || false;
        }
        return true;
    }
}
